import React from "react";
import HyperLink from "./HyperLink";
import PhoneLink from "./PhoneLink";
import EmailLink from "./EmailLink";
const reactStringReplace = require("react-string-replace");

const LinkifyText = (props) => {
	const text = props.text;
	const phoneRegex = /([\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6})/im;
	// const emailRegex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
	const emailRegex = /([^\s@]+@[^\s@]+\.[^\s@]+)/;
	// Match URLs
	let linkified = reactStringReplace(text, /(https?:\/\/\S+)/g, (match, i) => (
		<HyperLink key={match + i} url={match} title={match} />
	));
	// Emails
	linkified = reactStringReplace(linkified, emailRegex, (match, i) => <EmailLink key={match + i} email={match} />);
	// Match phone numbers  /(\d+)/g
	linkified = reactStringReplace(linkified, phoneRegex, (match, i) => <PhoneLink key={match + i} number={match} />);

	return <p style={props.style}>{linkified}</p>;
};

export default LinkifyText;
